import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {}

  disconnect() {}

  remove(event) {
    event.preventDefault()
    this.element.remove()
  }
}
